"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Drawer_1 = __importDefault(require("@mui/material/Drawer"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ActionButtons_1 = __importDefault(require("../common/ActionButtons"));
const CloseIconButton_1 = __importDefault(require("../common/CloseIconButton"));
const styles_1 = require("../common/styles");
const StyledDrawer = (0, styled_components_1.default)(Drawer_1.default) `
  .MuiDrawer-paper {
    box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14),
      0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.2);
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    height: ${({ height }) => height || "90%"};

    // This seems excessive but it's necessary to make sure our drawers always appear above ads
    z-index: 10000000000;
  }
`;
const StyledDrawerContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
`;
const ContentContainer = styled_components_1.default.div `
  padding: ${({ padding }) => padding || "24px 32px"};
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    padding: ${({ padding }) => padding || "24px"};
  }
`;
const TitleContainer = (0, styled_components_1.default)(ContentContainer) `
  padding-bottom: 0;
`;
const ChildrenContainer = (0, styled_components_1.default)(ContentContainer) `
  flex-grow: 1;
  overflow: scroll;
`;
const DrawerFooter = styled_components_1.default.div `
  padding: ${({ padding }) => padding || "24px 16px"};
  display: flex;
  justify-content: space-around;
  flex-direction: column;

  button {
    flex-grow: 1;
    + button {
      margin-top: 12px;
    }
  }
`;
/**
 * Generic drawer component.
 *
 * Extends Material's Drawer component.
 * See https://material-ui.com/api/drawer/ for full list of available props.
 */
const Drawer = ({ anchor = "bottom", title, subTitle, onClose, children, actions, hideCloseIcon, variant = "persistent", maxWidth, topDivider, bottomDivider, drawerHeight, drawerContentPadding, drawerFooterPadding, renderLargeSubTitle, ...rest }) => {
    const [scrollTarget, setScrollTarget] = (0, react_1.useState)(undefined);
    const isScrollable = scrollTarget && scrollTarget?.offsetHeight < scrollTarget?.scrollHeight;
    return ((0, jsx_runtime_1.jsxs)(StyledDrawer, { anchor: anchor, "data-testid": "buoy-drawer", height: drawerHeight, onClose: onClose, variant: variant, ...rest, children: [!hideCloseIcon && ((0, jsx_runtime_1.jsx)(styles_1.CloseButtonContainer, { children: (0, jsx_runtime_1.jsx)(CloseIconButton_1.default, { onClose: onClose }) })), (0, jsx_runtime_1.jsxs)(StyledDrawerContainer, { children: [(title || subTitle) && ((0, jsx_runtime_1.jsxs)(TitleContainer, { padding: drawerContentPadding, children: [title && (0, jsx_runtime_1.jsx)(styles_1.StyledTitle, { children: title }), subTitle &&
                                (renderLargeSubTitle ? ((0, jsx_runtime_1.jsx)(styles_1.StyledTitle, { renderLargeSubTitle: true, children: subTitle })) : ((0, jsx_runtime_1.jsx)(styles_1.SubTitle, { children: subTitle })))] })), (isScrollable || topDivider) && (0, jsx_runtime_1.jsx)(styles_1.StyledDivider, {}), (0, jsx_runtime_1.jsx)(ChildrenContainer, { ref: (node) => {
                            if (node) {
                                setScrollTarget(node);
                            }
                        }, padding: drawerContentPadding, children: children }), actions && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(isScrollable || bottomDivider) && (0, jsx_runtime_1.jsx)(Divider_1.default, {}), (0, jsx_runtime_1.jsx)(DrawerFooter, { padding: drawerFooterPadding, children: (0, jsx_runtime_1.jsx)(ActionButtons_1.default, { actions: actions }) })] }))] })] }));
};
exports.default = Drawer;
//# sourceMappingURL=index.js.map